import { API_ENDPOINTS } from "../config/api/apiCall";
import { Production_API_ENDPOINTS } from "../config/api/apiCallProduction";
import { callApi } from "../utils/apiClient";

export const removeMADetailFromParentRoll = async (payload) => {
    try {

        return await callApi(API_ENDPOINTS.PROD_MANAGEMENT_REMOVE_MA_DETAIL, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const updateMADetailFromParentRoll = async (payload) => {
    try {

        return await callApi(API_ENDPOINTS.PROD_MANAGEMENT_UPDATE_MA_DETAIL, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const getEmployeeSalarySlipDetail = async (payload) => {
    try {

        return await callApi(API_ENDPOINTS.SALARY_STRUCTURE_GET_SALARY_SLIP_BY_EMPLOYEE_ID, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const getMADetailWiseBalanceQty = async (payload) => {
    try {

        return await callApi(API_ENDPOINTS.PRODUCTION_PARENT_ROLL_MA_WISE_BALANCE_QTY, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const getUpdateReamPalletGrossWeight = async (payload) => {
    try {

        return await callApi(API_ENDPOINTS.REAM_PALLET_UPDATE_GROSS_WEIGHT, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const getTrackingDetails = async (payload) => {
    try {

        return await callApi(API_ENDPOINTS.TRACKING_GET_DETAIL_BY_SO_AND_CR, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const getActualSetValue = async (payload) => {
    try {

        return await callApi(API_ENDPOINTS.PRODUCTION_WINDER_ACTUAL_SET, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const getIndentInvoiceNoList = async (payload) => {
    try {
        return await callApi(Production_API_ENDPOINTS.GetIndentInvoiceNoForQCCertificate, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error fetching indent invoice numbers:", error);
        throw error;
    }
};

export const linkInvoiceNoToIndentNo = async (payload) => {
    try {
        return await callApi(Production_API_ENDPOINTS.linkInvoiceNoToIndentNoForQCCertificate, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error fetching linking indent invoice numbers:", error);
        throw error;
    }
};


export const getAllInvoiceNoList = async (payload) => {
    try {
        return await callApi(Production_API_ENDPOINTS.GetAllInvoiceNoForQCCertificate, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error fetching all invoice numbers:", error);
        throw error;
    }
};

export const getIndentNoListByInvoiceNo = async (payload) => {
    try {
        return await callApi(Production_API_ENDPOINTS.GetIndentNoListByInvoiceNo, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error fetching indent numbers by invoice:", error);
        throw error;
    }
};


export const productionSummaryToday = async (payload) => {
    try {
        return await callApi(Production_API_ENDPOINTS.ProductonSummaryToday, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading location type list:", error);
        throw error;
    }
};


export const productionSummaryMonthWise = async (payload) => {
    try {
        return await callApi(Production_API_ENDPOINTS.ProductonSummaryMonthWise, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading location type list:", error);
        throw error;
    }
};

export const productionSummaryRemarkWise = async (payload) => {
    try {
        return await callApi(Production_API_ENDPOINTS.ProductonSummaryRemarkWise, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading production summary remark wise:", error);
        throw error;
    }
};

export const updateChildReelGradeValue = async (payload) => {
    try {
        return await callApi(Production_API_ENDPOINTS.ProductionUpdateChildReelGrade, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading production summary remark wise:", error);
        throw error;
    }
};
